unable to read source [project]/momira.app/web/node_modules/src/zxing-html5-qrcode-decoder.ts